import { useRouter } from "next/router";
import { ParsedUrlQueryInput } from "querystring";

export function x(){
    
}
export enum ActionOrTriggerListFromEnum {
    project = 'project'
}
export enum ActionOrTriggerListTypeEnum {
    addAction = 'add',
    updateAction = 'update'
}
export interface IActionOrTriggerListPageParams extends ParsedUrlQueryInput {
    // 如果actionType是addAction，则target是taskData的ulid
    // 如果actionType是updateAction，则target是actionData的ulid
    // target: string
    // 动作列表里选择动作后要返回的路径
    backPath?: string
    // 本次操作的类型
    type: ActionOrTriggerListTypeEnum
    // projectClientUlid: string
    projectUlid:string
    triggerActionGroupUlid: string
    triggerActionUlid: string
    triggerGroupUlid?:string
    actionGroupUlid?: string
    // 如果是更新，则必须有actionId
    actionUlid?: string
    // 如果是添加，则必须有actionType
    // actionType为namespace/openApp这种样子的，这样能够从actionMap里找到这个action来进行添加
    // 这个需要在动作列表里选择了具体的action之后才能知道，所以在传递过程中这个可以为空，在pages/action-list/index.tsx里会根据actionId来找到具体的actionType
    actionType?: string

    triggerUlid?:string
    triggerType?:string
}

